// Listens for a Tab key press. If deteced 'tabbing' class is added
// to the html element and the listener is removed.
export default function detectTabbing() {
  const onKeyUp = function(e) {
    const charCode = e.which || e.keyCode
    if (charCode === 9) {
      document.documentElement.classList.add('tabbing')
      document.removeEventListener('keyup', onKeyUp)
    }
  }
  document.addEventListener('keyup', onKeyUp)
}